export const domain = "healthworks.uk.auth0.com";
export const clientId = process.env.VUE_APP_AUTH_CLIENT_ID;
export const audience = process.env.VUE_APP_AUTH_AUDIENCE;